import type { CSSProperties } from 'react';
import GeoService from '../../utils/GeoService';

// biome-ignore lint/suspicious/noExplicitAny: GeoService's Location shape is dynamic
type AnyData = any;

export interface LocationProps {
  location: {
    id: string;
    name: string;
    adm_0?: AnyData;
    adm_1?: AnyData;
    adm_2?: AnyData;
  };
  sx?: CSSProperties;
}

const CATEGORY: CSSProperties = {
  color: 'rgba(0, 0, 0, 0.50)',
  fontSize: '1.2rem',
};

const Location = ({ location, sx }: LocationProps) => {
  const isCity = GeoService.isCity(location);
  const isCounty = GeoService.isCounty(location);

  return (
    <div style={sx}>
      <div>{location.name}</div>
      {(isCounty || isCity) && (
        <div style={CATEGORY}>
          {location.adm_1?.name}, {location.adm_0?.Country}
        </div>
      )}
    </div>
  );
};

export default Location;
